import React from 'react';

/* import { useSelector, useDispatch } from 'react-redux';
import ICombinedState from '../../../../redux/model/ICombinedState';
import { changeCenter } from '../../../../redux/action/gmaps';
import { changeDay } from '../../../../redux/action/trip';
 */

import './Menu.scss';
// import {
//   // changeFavoritesVisible,
//   // changeSearchVisible,
//   // changeLocalExperiencesModalVisible,
// } from '../../../../redux/action/layout';

interface IMenu {
  listShown: boolean;
  showList: (event: React.MouseEvent<HTMLInputElement, MouseEvent>) => void;

  showExplorePlaces: () => void;
  showFavorites: () => void;
  showBookings: () => void;
  showLocalExperiences: () => void;

  /* 
  changeZoomProp: (zoom: number) => void;
  changeCenterProp: (latlng: Model.Coordinate) => void;
  */
}

const Menu: React.FC<IMenu> = ({ listShown, showList, showExplorePlaces, showFavorites, showBookings, showLocalExperiences }) => (
  /*   const dayIndex = useSelector((state: ICombinedState) => state.trip.day);  */

  <div className="menu">
    <div className="mitem search" onClick={showExplorePlaces} onKeyDown={() => {}} role="button" tabIndex={0}>
      {' '}
    </div>
    <div className="mitem favorites" onClick={showFavorites} onKeyDown={() => {}} role="button" tabIndex={0}>
      {' '}
    </div>
    <div className="mitem shape" />
    <div className={listShown ? 'circle shadow' : 'circle'}>
      <input className={listShown ? 'map-icon' : 'list-icon'} type="button" onClick={showList} />
    </div>
    <div className="mitem local-experiences" onClick={showLocalExperiences} onKeyDown={() => {}} role="button" tabIndex={0}>
      {' '}
    </div>
    <div className="mitem bookings" onClick={showBookings} onKeyDown={() => {}} role="button" tabIndex={0}>
      {' '}
    </div>
  </div>
);

export default Menu;
